import { render } from "./TableLayout.vue?vue&type=template&id=6d2cb8d2&scoped=true&ts=true"
import script from "./TableLayout.vue?vue&type=script&lang=ts"
export * from "./TableLayout.vue?vue&type=script&lang=ts"

import "./TableLayout.vue?vue&type=style&index=0&id=6d2cb8d2&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2cb8d2"]])

export default __exports__